import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function InfoSpeechPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const sectionStyle = {
    width: "100%",
    maxWidth: "800px",
    marginBottom: "60px",
    padding: "40px",
    border: "2px solid #ccc",
    borderRadius: "10px",
    backgroundColor: "#f9f9f9",
    textAlign: "left" as const,
  };

  const titleStyle = {
    color: "#333",
    borderBottom: "3px solid #007BFF",
    paddingBottom: "10px",
    marginBottom: "20px",
  };

  const listStyle = {
    fontSize: "18px",
    lineHeight: "2",
    textAlign: "left" as const,
    paddingLeft: "20px",
  };

  const cellHeader = {
    border: "1px solid #ccc",
    padding: "12px",
    backgroundColor: "#007BFF",
    color: "white",
    fontWeight: "bold" as const,
  };

  const cellStyle = {
    border: "1px solid #ccc",
    padding: "12px",
    textAlign: "left" as const,
  };

  const cellCenter = {
    border: "1px solid #ccc",
    padding: "12px",
    textAlign: "center" as const,
  };
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "40px", fontFamily: "Arial, sans-serif", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <nav style={{ marginBottom: "40px" }}>
        <ul style={{ listStyle: "none", padding: 0, display: "flex", justifyContent: "center", gap: "30px", fontSize: "20px" }}>
          <li><a href="/info#ai-line-bot" style={{ textDecoration: "none", color: "#007BFF" }}>AI 音声認識 × ChatGPT</a></li>
          <li><a href="/info#features" style={{ textDecoration: "none", color: "#007BFF" }}>機能</a></li>
          <li><a href="/info#use-cases" style={{ textDecoration: "none", color: "#007BFF" }}>活用事例</a></li>
          <li><a href="/info#pricing" style={{ textDecoration: "none", color: "#007BFF" }}>料金プラン</a></li>
        </ul>
      </nav>

      <section id="ai-line-bot" style={sectionStyle}>
        <h1 style={titleStyle}>🎤 AI 音声認識 × ChatGPT</h1>
        <p style={{ fontSize: "18px", lineHeight: "2" }}>
          高精度の音声認識と ChatGPT を組み合わせ、多言語対応の学習・ビジネス活用が可能！
        </p>
      </section>

      <section id="features" style={sectionStyle}>
        <h2 style={titleStyle}>✨ 主な機能</h2>
        <ul style={listStyle}>
          <li>🎙️ 音声認識 & 発話対応</li>
          <li>🌎 多言語対応（英語、日本語、中国語など）</li>
          <li>🧠 RAG（Retrieval-Augmented Generation）によるパーソナライズ</li>
          <li>💬 AIとのリアルタイムチャット & フィードバック</li>
        </ul>
      </section>

      <section id="use-cases" style={sectionStyle}>
        <h2 style={titleStyle}>🎯 活用事例</h2>
        <ul style={listStyle}>
          <li>✔ 英会話学習 & 面接対策</li>
          <li>✔ カスタマーサポート & FAQ自動応答</li>
          <li>✔ 店舗・企業向け自動案内</li>
          <li>✔ ビジネス用途のプレゼン練習 & 翻訳</li>
        </ul>
      </section>

      {/* <section id="pricing" style={sectionStyle}>
        <h2 style={titleStyle}>💰 料金プラン</h2>
        <ul style={listStyle}>
          <li><strong>無料プラン:</strong> 基本機能のみ（音声認識 & 翻訳）</li>
          <li><strong>スタンダードプラン（¥980/月）:</strong> AI応答の最適化・プロンプトカスタマイズ</li>
          <li><strong>プロフェッショナルプラン（¥2,980/月）:</strong> RAG対応・企業向けカスタム機能</li>
        </ul>
      </section> */}
      <section
        id="pricing"
        style={{
          width: "100%",
          marginBottom: "60px",
          padding: "20px",
          border: "2px solid #ccc",
          borderRadius: "10px",
          backgroundColor: "#f9f9f9",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#333", borderBottom: "2px solid #007BFF", paddingBottom: "10px" }}>
          💰 料金プラン
        </h2>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "30px",
          }}
        >
          <thead>
            <tr>
              <th style={cellHeader}>プラン</th>
              <th style={cellHeader}>無料</th>
              <th style={cellHeader}>スタンダード (¥980/月)</th>
              <th style={cellHeader}>プロ (¥2,980/月)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={cellStyle}>音声認識</td>
              <td style={cellCenter}>✅</td>
              <td style={cellCenter}>✅</td>
              <td style={cellCenter}>✅</td>
            </tr>
            <tr>
              <td style={cellStyle}>翻訳サポート</td>
              <td style={cellCenter}>✅</td>
              <td style={cellCenter}>✅</td>
              <td style={cellCenter}>✅</td>
            </tr>
            <tr>
              <td style={cellStyle}>AI応答カスタマイズ</td>
              <td style={cellCenter}>❌</td>
              <td style={cellCenter}>✅</td>
              <td style={cellCenter}>✅</td>
            </tr>
            <tr>
              <td style={cellStyle}>RAG（外部データ参照）</td>
              <td style={cellCenter}>❌</td>
              <td style={cellCenter}>❌</td>
              <td style={cellCenter}>✅</td>
            </tr>
            <tr>
              <td style={cellStyle}>法人カスタム対応</td>
              <td style={cellCenter}>❌</td>
              <td style={cellCenter}>❌</td>
              <td style={cellCenter}>✅</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
}

export default InfoSpeechPage;